import { isProd } from "../../config/isProd";
/**
 * @fileoverview Defines constants and configuration settings for analytics and event tracking.
 * @module CONSTANTS
 */

/**
 * Enumeration of event names used in tracking.
 * @enum {string}
 */
export const EVENTS = {
  ViewContent: "View-Content",
  PageView: "PageView",
  FindLocation: "FindLocation",
  Subscribe: "Subscribe",
  Contact: "Contact",
};


/**
 * Server-side API endpoints for tracking events.
 * @const {Object}
 */
export const API_ENDPOINTS = {
  Meta: "/wp-json/sanderson-farms/v2/meta",
  Pinterest: "/wp-json/sanderson-farms/v2/pinterest",
  Reddit: "/wp-json/sanderson-farms/v2/reddit",
  GeoLookup: "/wp-json/sanderson-farms/v2/geo-lookup"
};


// Dev Tracking IDs
const DEV_IDS = {
  Facebook_Pixel: "730383575846293",
  Pinterest_Pixel: "2613969654555",
  Tiktok_Pixel: "CT8C9N3C77UB52N3LVI0",
  Reddit_Pixel: "a2_h3pt2racw3gy",
  GA_Measurement: "G-RJ4CSSZ89S",
  Youtube_Conversion_ID: "AW-17131130719", // TODO - Update with actual dev ID, currently using production ID
  // Additional pixel IDs can be added here as needed
};

// Live Tracking IDs
const PROD_IDS = {
  Facebook_Pixel: "1239840427488071",
  Pinterest_Pixel: "2613784828481",
  Tiktok_Pixel: "CP313BRC77UAVOHT4H10",
  Reddit_Pixel: "a2_gzjnz6fh701u",
  GA_Measurement: "G-C23CYC73KE",
  Youtube_Conversion_ID: "AW-17131130719",
  // Additional pixel IDs can be added here as needed
};

// Export a function that returns the ID for a given platform based on if the domain contains sandersonfarms.com
export const getTrackingId = (platform) => {
  // If function isProd exists, use it to return prod IDs
  if ( typeof isProd === 'function' ) {
    const ids = isProd() ? PROD_IDS : DEV_IDS;
    return ids[platform] || null; // Return null if the platform ID is not found
  }
  return null;
};


